/* ============================================================
   ALBOREO · Guía de tallas — JavaScript
   ============================================================
   - Abre el drawer al clicar cualquier elemento con [data-alboreo-sg-open]
   - Cierra el drawer al clicar cualquier elemento con [data-alboreo-sg-close]
     o pulsar ESC, o clicar el overlay
   - Cambia de panel al clicar cualquier elemento con [data-alboreo-sg-tab]
   - Gestiona focus y aria-hidden para accesibilidad
   - Compatible con Shopify (no usa módulos, defer-safe)
   ============================================================ */

(function () {
  'use strict';

  function init() {
    const drawer  = document.getElementById('alboreoSgDrawer');
    const overlay = document.getElementById('alboreoSgOverlay');

    if (!drawer || !overlay) return;

    let lastFocusedElement = null;

    function openDrawer() {
      lastFocusedElement = document.activeElement;

      overlay.hidden = false;
      // Forzar reflow para que la transición funcione
      void overlay.offsetWidth;

      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('alboreo-sg-is-open');

      // Mover foco al botón de cerrar
      const closeBtn = drawer.querySelector('[data-alboreo-sg-close]');
      if (closeBtn) {
        setTimeout(function () { closeBtn.focus(); }, 100);
      }
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('alboreo-sg-is-open');

      // Devolver foco al elemento que abrió el drawer
      if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
        lastFocusedElement.focus();
      }

      // Ocultar overlay tras la animación
      setTimeout(function () {
        if (!overlay.classList.contains('is-open')) {
          overlay.hidden = true;
        }
      }, 450);
    }

    function switchTab(targetKey) {
      const tabs   = drawer.querySelectorAll('[data-alboreo-sg-tab]');
      const panels = drawer.querySelectorAll('.alboreo-sg-panel');

      tabs.forEach(function (t) {
        const isActive = t.getAttribute('data-alboreo-sg-tab') === targetKey;
        t.classList.toggle('is-active', isActive);
        t.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      panels.forEach(function (p) {
        p.classList.remove('is-active');
      });

      const targetPanel = document.getElementById('alboreoSgPanel-' + targetKey);
      if (targetPanel) {
        targetPanel.classList.add('is-active');
        // Scroll suave al panel activado
        setTimeout(function () {
          targetPanel.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 50);
      }
    }

    // Delegación de eventos para botones de abrir/cerrar/tabs
    document.addEventListener('click', function (e) {
      const opener = e.target.closest('[data-alboreo-sg-open]');
      if (opener) {
        e.preventDefault();
        openDrawer();
        return;
      }

      const closer = e.target.closest('[data-alboreo-sg-close]');
      if (closer) {
        e.preventDefault();
        closeDrawer();
        return;
      }

      const tab = e.target.closest('[data-alboreo-sg-tab]');
      if (tab && drawer.contains(tab)) {
        e.preventDefault();
        switchTab(tab.getAttribute('data-alboreo-sg-tab'));
      }
    });

    // ESC para cerrar
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeDrawer();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
